const photos = [
  {
    id: 1,
    src: "https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/f43f61eb-c472-49a4-9ea7-4d10418471b7_1000013060.jpg?v=42a6393e847507376bc5f7222eb9edb3",
    alt: "Gallery Pizza interior atmosphere",
    span: "col-span-1 row-span-2",
    fit: "object-cover",
  },
  {
    id: 2,
    src: "https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/ff4851f0-6e4f-42f9-aad3-655d35799dbf_seafood-pizza.jpg?v=b56783f839f23487dc461975c2512101",
    alt: "Seafood pizza",
    span: "col-span-1 row-span-1",
    fit: "object-contain",
  },
  {
    id: 3,
    src: "https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/4cb3170f-ce35-4214-bb60-8e63a6a21979_473577296_1202487598546570_8800318746349790420_n.jpg?v=de6372698c4e8a6a70f9263326e52bc7",
    alt: "Gallery Pizza restaurant",
    span: "col-span-1 row-span-1",
    fit: "object-contain",
  },
  {
    id: 4,
    src: "https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/54262862-ca1a-43fe-82fc-04294d7b0881_666636822_1608726697922656_1299990976584011043_n.jpg?v=35558f4ecd372d33b28ff74d5d810d68",
    alt: "Gallery Pizza special",
    span: "col-span-1 row-span-1",
    fit: "object-contain",
  },
  {
    id: 5,
    src: "https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/86f82485-939b-4743-980c-89e8059e9aa7_666183535_1608726341256025_5077321518537768252_n.jpg?v=ae84528e14d15a0927b5461424983b4f",
    alt: "Gallery Pizza creation",
    span: "col-span-1 row-span-1",
    fit: "object-contain",
  },
  {
    id: 6,
    src: "https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/6be9432e-54ff-4384-b6fa-4940693117af_666295198_1608726261256033_4661367882268786927_n.jpg?v=d6986fa1d4ec075b9a9fe349d6d00c8d",
    alt: "Gallery Pizza dish",
    span: "col-span-1 row-span-1",
    fit: "object-contain",
  },
];

export default function PhotosSection() {
  return (
    <section id="photos" className="bg-[#1A1A1A] py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <p className="text-[#FF6B35] text-xs font-semibold tracking-[0.25em] uppercase mb-3">Gallery</p>
            <h2 className="text-[#FAF8F5] font-extrabold text-4xl md:text-5xl leading-tight">
              Pizza Meets <span className="text-[#8B6F47]">Art</span>
            </h2>
          </div>
          <p className="text-[#FAF8F5]/50 text-sm max-w-xs leading-relaxed">
            Art on the walls, a welcoming space, and the smell of fresh pizza — a place people remember.
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[220px]">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className={`${photo.span} rounded-2xl overflow-hidden group cursor-pointer bg-[#111111]`}
            >
              <div className="relative w-full h-full">
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className={`w-full h-full ${photo.fit} object-center group-hover:scale-105 transition-transform duration-500`}
                />
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/30 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FAF8F5]/0 group-hover:bg-[#FAF8F5]/20 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100">
                    <i className="ri-zoom-in-line text-[#FAF8F5] text-xl" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Instagram CTA */}
        <div className="mt-10 text-center">
          <p className="text-[#FAF8F5]/50 text-sm mb-4">Follow us for more food &amp; atmosphere</p>
          <a
            href="https://www.instagram.com/gallerypizzahvollywood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-[#FAF8F5]/20 text-[#FAF8F5] font-semibold text-sm px-7 py-3 rounded-full hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line text-base" />
            @gallerypizza
          </a>
        </div>
      </div>
    </section>
  );
}
